module.exports = require("ramda/src/insert");